const mutinyIdentify = ({
  email,
  firstName,
  lastName,
  companyName,
  companyWebsite,
  companySize,
  country,
}) => {
  const identityData = { email };
  const companyData = {};
  const addressData = {};

  if (firstName) identityData.firstName = firstName;
  if (lastName) identityData.lastName = lastName;

  if (companyName) companyData.name = companyName;
  if (companyWebsite) companyData.domain = companyWebsite;
  if (companySize) companyData.employeeCount = companySize;

  if (country) addressData.country = country;

  if (Object.keys(companyData).length > 0) identityData.company = companyData;
  if (Object.keys(addressData).length > 0) identityData.address = addressData;

  if (typeof window !== 'undefined') {
    window?.mutiny?.client?.identify(null, identityData);
  }
};

export default mutinyIdentify;
